/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@rxdi/core';

@Injectable()
export class PrefetchService {
  async fetch(m: any) {
    //  m: Promise<any>
    // await m;
  }
}
